import React from 'react'

/**
 * Minimal InputNumber replicating the logic/panels/helpers/InputNumber component.
 * Used inside PlayScreen slider components for numeric value display/edit.
 */
function InputNumber({
    value = 0,
    onChange,
    min = 0,
    max = 255,
    disabled = false,
    style: customStyle,
}) {
    const handleChange = (e) => {
        let val = e.target.value
        if (val === '') {
            onChange(0)
            return
        }
        val = Number(val)
        if (val < min) val = min
        else if (val > max) val = max
        onChange(val)
    }

    const baseStyle = {
        width: '56px',
        height: '25px',
        display: 'inline-block',
        textAlign: 'center',
        borderRadius: '9px',
        color: 'black',
        border: '1px solid hsl(0, 0%, 0%)',
        ...(disabled ? { borderBottom: '0.140em solid #B8B8B8' } : {}),
        ...customStyle,
    }

    return (
        <input
            className="play-input-digit"
            style={baseStyle}
            type="text"
            inputMode="numeric"
            value={value}
            min={min}
            max={max}
            disabled={disabled}
            onChange={handleChange}
        />
    )
}

export default InputNumber
